<template>
	<section id="permissions" class="user-profile">
		<section
			class="b360-grid-row preference-center-section"
			v-for="section in sections"
			:key="section.id"
		>
			<title-description
				class="b360-col-xs-12 b360-col-sm-12 b360-col-md-4 b360-col-lg-4 form-title-description"
				:title="section.title"
				:description="section.description"
			></title-description>
			<div class="b360-col-xs-12 b360-col-sm-12 b360-col-md-8">
				<section class="top-btn-wrapper">
					<button
						type="button"
						id="manage-users"
						class="b360-btn--primary top-right-btn"
						v-on:click="urlLink(easeBaseUrl)"
					>
						<font-awesome-icon
							class="manage-user-icon"
							:icon="['far', 'users']"
						/>Manage Users
					</button>
				</section>
				<Accordion
					v-for="(role, roleIndex) in roleList"
					:key="roleIndex"
					:name="role.role"
					:accordionLabel="role.roleDescription"
					v-if="role.role === 'MarketingManager' || role.role === 'LoanOfficer'"
				>
					<PermissionsToggles
						slot="accordionContent"
						:permissionsListProp="role.permissions"
						:roleListIndexProp="roleIndex"
						:roleNameProp="role.role"
					/>
				</Accordion>
			</div>
		</section>
		<save-button
			:waiting="savingState"
			:saved="savedState"
			:disabled="$store.getters.isReadOnlyPermission()"
			@handle-click="saveAllRolePermissions(organizationId, allRolePermission)"
		></save-button>
	</section>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import TitleDescription from '@/components/global/TitleDescription.vue';
import PermissionsToggles from '@/components/preference-center/PermissionsToggles.vue';
import Accordion from '@/components/global/Accordion.vue';
import preferenceCenterPermissionApiService from '@/services/profile/profile-service';
import SaveButton from '@/components/preference-center/SaveButton';

export default {
	name: 'PreferenceCenterPermissions',
	components: {
		TitleDescription,
		Accordion,
		PermissionsToggles,
		SaveButton,
	},
	computed: mapState({
		personalDetails: (state) => state.profile,
		fullName: (state) => `${state.profile.firstName} ${state.profile.lastName}`,
		roleList: (state) => state.preferenceCenterPermissions.rolesList,
		allRolePermission: (state) => state.preferenceCenterPermissions.rolesList,
		organizationId: (state) => state.profile.organizationId[0],
		privileges: (state) => state.preferenceCenterPermissions.privileges,
		easeBaseUrl: (state) => state.profile.easeBaseUrl,
		permissions: (state) => state.preferenceCenterPermissions,
	}),
	methods: {
		...mapActions([
			'userProfileDataAction',
			'fullNameDataAction',
			'profileStateAction',
		]),

		urlLink(baseUrl) {
			window.location.href = `${baseUrl}/Lending/Account/Settings`;
		},

		async saveAllRolePermissions(organizationId, allRolePermission) {
			this.savingState = true;
			if (document.getElementById('preference-center-form').reportValidity()) {
				await preferenceCenterPermissionApiService
					.saveRolePermissions(organizationId, allRolePermission)
					.then((data) => {
						if (data) {
							this.savingState = false;
							this.savedState = true;
						}
					});
			} else {
				this.savingState = false;
				const formElements = document.querySelectorAll('input, select');
				formElements.forEach((el) => {
					el.addEventListener('invalid', function () {
						this.scrollIntoView(false);
					});
				});
			}

			this.$store.commit('PERMISSION_ISEDITED');

			setTimeout(() => {
				this.savingState = false;
				this.savedState = false;
			}, 10000);
		},
	},
	data() {
		return {
			sections: [
				{
					id: 0,
					title: 'Permissions',
					description: 'Set permission levels by role for Brand 360 access.',
				},
			],
			savedState: false,
			savingState: false,
		};
	},
	beforeRouteLeave(to, from, next) {
		if (this.permissions.isEdited === true) {
			const answer = window.confirm(
				'There are unsaved changes in the form.  Are you sure you want to continue?',
			);

			answer ? next() : next(false);
		} else {
			next();
		}
	},
};
</script>

<style scoped lang="scss">
.top-btn-wrapper {
	display: flex;
}

.top-right-btn {
	@include flex-align-right;
	@include rem(margin-bottom, 15px);

	@include mobile {
		width: 100%;
	}
}

.manage-user-icon {
	@include rem(margin-right, 12px);
}
</style>
